module.exports = __webpack_public_path__ + "img/van_houtte.a944a390.webp";